
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as popupXg1kAa7mIvF08tfmgdCaQXvnE_8QFGTXRGNWywDB2wIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/notifications/popup.vue?macro=true";
import { default as simpleziT6_BIwZUDrKlc2r7B4IbR9VLKZvmyPTsTaQ2hbCZUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/simple.vue?macro=true";
import { default as _91id_93aQttI4RRyTy6_PSltjamOGTCshyfdxWiJoG1taRPa8IMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/detail/[id].vue?macro=true";
import { default as indexSBz2ZuGOUQNCAZulo_qf4egqvoKQzpAdJZxgN8bd1s8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/post/[id]/index.vue?macro=true";
import { default as _91id_93DqLUDP5zWVwp2sRJn3c6b30FefMo_K8H366io4tocdUMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/[id].vue?macro=true";
import { default as badgeFqwUR3e5HFwZYGx_5k7_BpQ7y2iPacP4MxJTkVLkCUAMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/badge.vue?macro=true";
import { default as birthdaygLJLhrNTGUawBDnyuxlsFXZaMm_G5fV7y9D0JUmeTggMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/birthday.vue?macro=true";
import { default as birthdayweeklr1yw70aFnoCaWvIWo7ErWpN8LsneBCB4XsYX_UiZkQMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/birthdayweek.vue?macro=true";
import { default as christmasOdMaI3DGeJSNj4dH4_AhnyFbVUfi88GmdeYEc0u1NB8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/christmas.vue?macro=true";
import { default as levelupCaDgtRhSNd4VY7d_ycbANqQ5lCqCOwZAKtYWLVM32XsMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/levelup.vue?macro=true";
import { default as profileWss5Xb8_gyAHxpcDB61W02a2uoZctLZXUXfnO54sz_8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/profile.vue?macro=true";
import { default as registermMRrLa7Zy9dXvoV1M_MseLWEJSbNAlmzmOzEus0ustIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/register.vue?macro=true";
import { default as specialday3j3qEkuS2ZaWxdb3m6C9rPb3iirzQwe_0FtGejSlaK8Meta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/specialday.vue?macro=true";
import { default as prizewheelp0n3HAfxofZDGyudu4tjqgGo9UJec9AP8oIJ97O30_QMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/prizewheel.vue?macro=true";
import { default as profilek4SDRdTlMa3jJr7CwoER_K1caIih7kV28AVyg17f4AIMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/profile.vue?macro=true";
import { default as quizl8ZCkpUjFKE5v0eM_PVU8d3BXwJjU5RaHwPKAFZb0ZwMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/quiz.vue?macro=true";
import { default as indexzD5i_AduqFRFYblZ41TUwhPDRSOL4JlSGBV8YViuKjYMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/index.vue?macro=true";
import { default as indexC7pglel7YGRqdIQodU2VJojWY_RmuRirxQEXjPjUiuMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/index.vue?macro=true";
import { default as user_BwvKnz_awclI764K2jvuYQMkTnJ88D5EpqxWHrT3FMMeta } from "/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/user.vue?macro=true";
export default [
  {
    name: "me-rewards-detail-coupon-id",
    path: "/me/rewards/detail/coupon/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/coupon/[id].vue")
  },
  {
    name: "me-rewards-detail-custom-id",
    path: "/me/rewards/detail/custom/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/custom/[id].vue")
  },
  {
    name: "me-rewards-detail-id",
    path: "/me/rewards/detail/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/detail/[id].vue")
  },
  {
    name: "me-profile-avatar",
    path: "/me/profile/avatar",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/avatar.vue")
  },
  {
    name: "me-profile-rewards",
    path: "/me/profile/rewards",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/rewards.vue")
  },
  {
    name: "me-rewards-plus",
    path: "/me/rewards/plus",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/plus.vue")
  },
  {
    name: "preview-notifications-popup",
    path: "/preview/notifications/popup",
    meta: popupXg1kAa7mIvF08tfmgdCaQXvnE_8QFGTXRGNWywDB2wIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/notifications/popup.vue")
  },
  {
    name: "preview-rewards-detail",
    path: "/preview/rewards/detail",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/detail.vue")
  },
  {
    name: "preview-rewards-largecard",
    path: "/preview/rewards/largecard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/largecard.vue")
  },
  {
    name: "preview-rewards-smallcard",
    path: "/preview/rewards/smallcard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/rewards/smallcard.vue")
  },
  {
    name: "preview-specials-special",
    path: "/preview/specials/special",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/specials/special.vue")
  },
  {
    name: "widget-special-simple",
    path: "/widget/special/simple",
    meta: simpleziT6_BIwZUDrKlc2r7B4IbR9VLKZvmyPTsTaQ2hbCZUMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/simple.vue")
  },
  {
    name: "me-posts-id",
    path: "/me/posts/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/posts/[id].vue")
  },
  {
    name: "me-special-slug",
    path: "/me/special/:slug()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/special/[slug].vue")
  },
  {
    name: "me-voucher-id",
    path: "/me/voucher/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/voucher/[id].vue")
  },
  {
    name: "notification-detail-id",
    path: "/notification/detail/:id()",
    meta: _91id_93aQttI4RRyTy6_PSltjamOGTCshyfdxWiJoG1taRPa8IMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/detail/[id].vue")
  },
  {
    name: "widget-post-id",
    path: "/widget/post/:id()",
    meta: indexSBz2ZuGOUQNCAZulo_qf4egqvoKQzpAdJZxgN8bd1s8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/post/[id]/index.vue")
  },
  {
    name: "widget-reward-id",
    path: "/widget/reward/:id()",
    meta: _91id_93DqLUDP5zWVwp2sRJn3c6b30FefMo_K8H366io4tocdUMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/[id].vue")
  },
  {
    name: "me-challenges",
    path: "/me/challenges",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/challenges.vue")
  },
  {
    name: "me-faq",
    path: "/me/faq",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/faq.vue")
  },
  {
    name: "me-friends",
    path: "/me/friends",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/friends.vue")
  },
  {
    name: "me-leaderboard",
    path: "/me/leaderboard",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/leaderboard.vue")
  },
  {
    name: "me-moreFriends",
    path: "/me/moreFriends",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/moreFriends.vue")
  },
  {
    name: "me-open",
    path: "/me/open",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/open.vue")
  },
  {
    name: "me-overview",
    path: "/me/overview",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/overview.vue")
  },
  {
    name: "me-profile",
    path: "/me/profile",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/profile/index.vue")
  },
  {
    name: "me-rewards",
    path: "/me/rewards",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/rewards/index.vue")
  },
  {
    name: "me-voucher",
    path: "/me/voucher",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/me/voucher/index.vue")
  },
  {
    name: "notification-badge",
    path: "/notification/badge",
    meta: badgeFqwUR3e5HFwZYGx_5k7_BpQ7y2iPacP4MxJTkVLkCUAMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/badge.vue")
  },
  {
    name: "notification-birthday",
    path: "/notification/birthday",
    meta: birthdaygLJLhrNTGUawBDnyuxlsFXZaMm_G5fV7y9D0JUmeTggMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/birthday.vue")
  },
  {
    name: "notification-birthdayweek",
    path: "/notification/birthdayweek",
    meta: birthdayweeklr1yw70aFnoCaWvIWo7ErWpN8LsneBCB4XsYX_UiZkQMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/birthdayweek.vue")
  },
  {
    name: "notification-christmas",
    path: "/notification/christmas",
    meta: christmasOdMaI3DGeJSNj4dH4_AhnyFbVUfi88GmdeYEc0u1NB8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/christmas.vue")
  },
  {
    name: "notification-levelup",
    path: "/notification/levelup",
    meta: levelupCaDgtRhSNd4VY7d_ycbANqQ5lCqCOwZAKtYWLVM32XsMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/levelup.vue")
  },
  {
    name: "notification-profile",
    path: "/notification/profile",
    meta: profileWss5Xb8_gyAHxpcDB61W02a2uoZctLZXUXfnO54sz_8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/profile.vue")
  },
  {
    name: "notification-register",
    path: "/notification/register",
    meta: registermMRrLa7Zy9dXvoV1M_MseLWEJSbNAlmzmOzEus0ustIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/register.vue")
  },
  {
    name: "notification-specialday",
    path: "/notification/specialday",
    meta: specialday3j3qEkuS2ZaWxdb3m6C9rPb3iirzQwe_0FtGejSlaK8Meta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/notification/specialday.vue")
  },
  {
    name: "widget-main",
    path: "/widget/main",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/main.vue")
  },
  {
    name: "widget-prizewheel",
    path: "/widget/prizewheel",
    meta: prizewheelp0n3HAfxofZDGyudu4tjqgGo9UJec9AP8oIJ97O30_QMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/prizewheel.vue")
  },
  {
    name: "widget-profile",
    path: "/widget/profile",
    meta: profilek4SDRdTlMa3jJr7CwoER_K1caIih7kV28AVyg17f4AIMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/profile.vue")
  },
  {
    name: "widget-quiz",
    path: "/widget/quiz",
    meta: quizl8ZCkpUjFKE5v0eM_PVU8d3BXwJjU5RaHwPKAFZb0ZwMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/quiz.vue")
  },
  {
    name: "widget-reward",
    path: "/widget/reward",
    meta: indexzD5i_AduqFRFYblZ41TUwhPDRSOL4JlSGBV8YViuKjYMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/reward/index.vue")
  },
  {
    name: "widget-special",
    path: "/widget/special",
    meta: indexC7pglel7YGRqdIQodU2VJojWY_RmuRirxQEXjPjUiuMMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/special/index.vue")
  },
  {
    name: "widget-user",
    path: "/widget/user",
    meta: user_BwvKnz_awclI764K2jvuYQMkTnJ88D5EpqxWHrT3FMMeta || {},
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/widget/user.vue")
  },
  {
    name: "preview-type-id",
    path: "/preview/:type()/:id()",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/preview/[type]/[id].vue")
  },
  {
    name: "open",
    path: "/open",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/open.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/DEVV/russmedia-frontend-nuxt3/apps/tee/laendlepunkte/app/pages/index.vue")
  }
]